"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _useUtils = require("../../_helpers/use-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Animate.css");

var _styles = {
  "animation": "Animate__animation___1PbtM",
  "start-invisible": "Animate__start-invisible___3e41I",
  "start-zoom": "Animate__start-zoom___1jZ9q",
  "start-directional": "Animate__start-directional___352mC",
  "zoom-in-with-box-shadow": "Animate__zoom-in-with-box-shadow___1pMuF",
  "fade": "Animate__fade___3VPq7",
  "scale": "Animate__scale___HdhiS",
  "directional-in": "Animate__directional-in___3LiUW",
  "directional-out": "Animate__directional-out___3F2GS"
};

const styles = _bind.default.bind(_styles);

const Animate = (0, _mobxReact.observer)(({
  dataTestId,
  className,
  children,
  enter,
  exit,
  duration = 1,
  delay = 0,
  enterPosition,
  exitDelay = 1,
  exitDuration = 0,
  exitPosition,
  unmountOnExit,
  ...props
}) => {
  exitDuration = exitDuration || duration;

  const hasKey = (key, type) => {
    if (type === undefined) {
      return false;
    } else if (typeof type === 'string') {
      return type === key;
    } else {
      return type.includes(key);
    }
  };

  const timeToUnmount = delay + duration + exitDelay + exitDuration;
  const animateRef = (0, _react.useRef)(null);
  (0, _useUtils.useDelayedEffectOnce)(timeToUnmount * 1000, () => {
    if (unmountOnExit && exit && animateRef.current) {
      animateRef.current.remove();
    }
  });
  const animationProps = {
    animationName: [],
    animationDuration: [],
    animationDelay: [],
    animationDirection: [],
    animationTimingFunction: [],
    animationIterationCount: []
  };

  if (enter !== undefined) {
    (Array.isArray(enter) ? enter : [enter]).forEach(type => {
      switch (type) {
        case 'fade-in':
          animationProps.animationName.push('fade');
          break;

        case 'from-left':
        case 'from-right':
        case 'from-bottom':
        case 'from-top':
        case 'directional':
          animationProps.animationName.push('directional-in');
          break;

        case 'zoom-in':
        case 'zoom-in-with-box-shadow':
          animationProps.animationName.push('scale');
          break;

        default:
          throw new Error(`Unknown enter animation type '${type}'`);
      }

      animationProps.animationDuration.push(`${duration}s`);
      animationProps.animationDelay.push(`${delay}s`);
      animationProps.animationDirection.push('normal');
      animationProps.animationTimingFunction.push(`cubic-bezier(0.42, 0, 0.58, 1)`);
      animationProps.animationIterationCount.push(`1`);
    });
  }

  if (exit !== undefined) {
    (Array.isArray(exit) ? exit : [exit]).forEach(type => {
      switch (type) {
        case 'fade-out':
          animationProps.animationName.push('fade');
          animationProps.animationDirection.push('reverse');
          break;

        case 'to-left':
        case 'to-right':
        case 'to-bottom':
        case 'to-top':
        case 'directional':
          animationProps.animationName.push('directional-out');
          animationProps.animationDirection.push('normal');
          break;

        case 'zoom-out':
          animationProps.animationName.push('scale');
          animationProps.animationDirection.push('reverse');
          break;

        default:
          throw new Error(`Unknown enter animation type '${type}'`);
      }

      animationProps.animationDuration.push(`${exitDuration || duration}s`);
      animationProps.animationDelay.push(`${delay + duration + exitDelay}s`);
      animationProps.animationTimingFunction.push(`cubic-bezier(0.42, 0, 0.58, 1)`);
      animationProps.animationIterationCount.push(`1`);
    });
  }

  if (!animationProps.animationName.length) {
    throw new Error('Must provide at least one animation enter or exit type');
  }

  const composed_classnames = (0, _bind.default)(styles('animation', {
    'start-invisible': hasKey('fade-in', enter),
    'start-zoom': hasKey('zoom-in', enter) || hasKey('zoom-in-with-box-shadow', enter),
    'start-directional': hasKey('to-top', enter) || hasKey('to-bottom', enter) || hasKey('to-left', enter) || hasKey('to-right', enter) || hasKey('directional', enter),
    'zoom-in-with-box-shadow': hasKey('zoom-in-with-box-shadow', enter)
  }), className);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classnames,
    ref: animateRef,
    style: {
      animationName: animationProps.animationName.map(name => styles(name)).join(', '),
      animationDuration: animationProps.animationDuration.join(', '),
      animationDelay: animationProps.animationDelay.join(', '),
      animationDirection: animationProps.animationDirection.join(', '),
      animationTimingFunction: animationProps.animationTimingFunction.join(', '),
      animationIterationCount: animationProps.animationIterationCount.join(', '),
      '--animate-after-delay': `${(delay || 0) + 0.25}s`,
      '--animate-after-duration': `${duration}s`,
      '--animate-start-x': hasKey('directional', enter) ? `${(enterPosition === null || enterPosition === void 0 ? void 0 : enterPosition.x) || 0}px` : hasKey('from-left', enter) ? '-75px' : hasKey('from-right', enter) ? '75px' : 0,
      '--animate-start-y': hasKey('directional', enter) ? `${(enterPosition === null || enterPosition === void 0 ? void 0 : enterPosition.y) || 0}px` : hasKey('from-top', enter) ? '-75px' : hasKey('from-bottom', enter) ? '75px' : 0,
      '--animate-end-x': hasKey('directional', exit) ? `${(exitPosition === null || exitPosition === void 0 ? void 0 : exitPosition.x) || 0}px` : hasKey('to-left', exit) ? '-75px' : hasKey('to-right', exit) ? '75px' : 0,
      '--animate-end-y': hasKey('directional', exit) ? `${(exitPosition === null || exitPosition === void 0 ? void 0 : exitPosition.y) || 0}px` : hasKey('to-top', exit) ? '-75px' : hasKey('to-bottom', exit) ? '75px' : 0
    },
    ...props
  }, children);
});
var _default = Animate;
exports.default = _default;